/** @file keyWarnings: UNKNOWN_NODE_IN_CLIP for the unknown nodes the written keys name (not older ones). */
import type { Clip, ClipKey } from '@zilo/pose3d-format/types/clip';
import type { Warning } from '@zilo/pose3d-format/types/warning';
import type { PuppetDoc } from '../puppetDoc/puppetDoc';
import { unknownNodeWarnings } from './unknownNodeWarnings';

/** The clip's unknown-node warnings restricted to nodes `keys` name (key nodes, flex parents, event nodes). */
export function keyWarnings(draft: PuppetDoc, name: string, clip: Clip, keys: readonly ClipKey[]): Warning[] {
  const named = new Set(keys.flatMap((k) => [
    ...Object.keys(k.nodes), ...Object.values(k.nodes).flatMap((n) => (typeof n.parent === 'string' ? [n.parent] : [])),
    ...(k.events ?? []).flatMap((e) => (e.node === undefined ? [] : [e.node])),
  ]));
  return unknownNodeWarnings(draft.puppet, name, clip).filter((w) => named.has(String(w.params?.node)));
}
